export default "__VITE_ASSET__DS4JoXIb__"